import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../constants';

const IDS = {
  LOANS_BUTTON_LABEL_SELECTLOAN: 'navigation.loans.button.label.selectLoan',
  LOANS_MODAL_ARIALABEL: 'navigation.loans.modal.ariaLabel',
  LOANS_MODAL_HEADER: 'navigation.loans.modal.header',
  LOANS_SELECT_HEADING: 'navigation.loans.modal.heading',
  LOANS_SELECT_PARAGRAPH: 'navigation.loans.modal.paragraph',
  LOANS_SELECT_UNAVAILABLE_LOANNUMBER: 'navigation.loans.modal.unavailable.loannumber',
  LOANS_SELECT_UNAVAILABLE_STATUS: 'navigation.loans.modal.unavailable.status',
};

const enMessages = {
  [IDS.LOANS_BUTTON_LABEL_SELECTLOAN]: 'Switch Loans',
  [IDS.LOANS_MODAL_ARIALABEL]: 'Switch Loan',
  [IDS.LOANS_MODAL_HEADER]: 'Select a Loan',
  [IDS.LOANS_SELECT_HEADING]: '{userDisplayName}\'s loans.',
  [IDS.LOANS_SELECT_PARAGRAPH]: 'Select a loan to make a payment, view details, and more.',
  [IDS.LOANS_SELECT_UNAVAILABLE_LOANNUMBER]: 'Loan {maskedLoanNumber}',
  [IDS.LOANS_SELECT_UNAVAILABLE_STATUS]: 'Loan Not Available',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.LOANS_BUTTON_LABEL_SELECTLOAN]: 'Switch Accounts',
  [IDS.LOANS_MODAL_ARIALABEL]: 'Switch Account',
  [IDS.LOANS_MODAL_HEADER]: 'Select an Account',
  [IDS.LOANS_SELECT_HEADING]: '{userDisplayName}\'s accounts',
  [IDS.LOANS_SELECT_PARAGRAPH]: 'Select an account to make a payment, view details, and more.',
  [IDS.LOANS_SELECT_UNAVAILABLE_LOANNUMBER]: 'Account {maskedLoanNumber}',
  [IDS.LOANS_SELECT_UNAVAILABLE_STATUS]: 'Account Not Available',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
